module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/bold_1-24f444197ae4679bb315bf1399b9a526.png";